import React from 'react';
import { Box } from '@mui/material';

import AddItems from './AddItems';
import AddPage from './AddPage';
import DeleteDocument from './DeleteDocument';
import FitToPage from './FitToPage';
import MoreOptions from './MoreOptions';
import RemovePage from './RemovePage';
import ReorderDocuments from './ReorderDocuments';
import ReplaceComponents from './ReplaceComponents';

const buttonSx = { width: '100%', m: 'auto' } as const;

export default function DocumentManagerButtons() {
  return (
    <Box
      sx={{
        justifyContent: 'space-around',
        width: '100%',
        display: 'flex',
        borderTop: 'solid 1px',
        borderBottom: 'solid 1px',
        borderTopColor: 'backContrast.main',
        borderBottomColor: 'backContrast.main',
      }}
    >
      <Box sx={buttonSx}>
        <AddItems />
      </Box>
      <Box sx={buttonSx}>
        <DeleteDocument />
      </Box>
      <Box sx={buttonSx}>
        <AddPage />
      </Box>
      <Box sx={buttonSx}>
        <RemovePage />
      </Box>
      <Box sx={buttonSx}>
        <ReplaceComponents />
      </Box>
      <Box sx={buttonSx}>
        <ReorderDocuments />
      </Box>
      <Box sx={buttonSx}>
        <MoreOptions />
      </Box>
      <Box sx={buttonSx}>
        <FitToPage />
      </Box>
    </Box>
  );
}
